// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function address_encode(v) {
  return Js_dict.fromArray([
              [
                "receiver_name",
                Decco.optionToJson(Decco.stringToJson, v.receiver_name)
              ],
              [
                "receiver_phone",
                Decco.optionToJson(Decco.stringToJson, v.receiver_phone)
              ],
              [
                "address_line_1",
                Decco.optionToJson(Decco.stringToJson, v.address_line_1)
              ],
              [
                "address_line_2",
                Decco.optionToJson(Decco.stringToJson, v.address_line_2)
              ],
              [
                "city",
                Decco.optionToJson(Decco.stringToJson, v.city)
              ],
              [
                "state",
                Decco.optionToJson(Decco.stringToJson, v.state)
              ],
              [
                "postal_code",
                Decco.optionToJson(Decco.stringToJson, v.postal_code)
              ]
            ]);
}

function address_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var receiver_name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "receiver_name"), null));
  if (receiver_name.TAG === /* Ok */0) {
    var receiver_phone = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "receiver_phone"), null));
    if (receiver_phone.TAG === /* Ok */0) {
      var address_line_1 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "address_line_1"), null));
      if (address_line_1.TAG === /* Ok */0) {
        var address_line_2 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "address_line_2"), null));
        if (address_line_2.TAG === /* Ok */0) {
          var city = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "city"), null));
          if (city.TAG === /* Ok */0) {
            var state = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "state"), null));
            if (state.TAG === /* Ok */0) {
              var postal_code = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "postal_code"), null));
              if (postal_code.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          receiver_name: receiver_name._0,
                          receiver_phone: receiver_phone._0,
                          address_line_1: address_line_1._0,
                          address_line_2: address_line_2._0,
                          city: city._0,
                          state: state._0,
                          postal_code: postal_code._0
                        }
                      };
              }
              var e = postal_code._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".postal_code" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = state._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".state" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = city._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".city" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = address_line_2._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".address_line_2" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = address_line_1._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".address_line_1" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = receiver_phone._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".receiver_phone" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = receiver_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".receiver_name" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function item_encode(v) {
  return Js_dict.fromArray([
              [
                "sku",
                Decco.stringToJson(v.sku)
              ],
              [
                "quantity",
                Decco.intToJson(v.quantity)
              ]
            ]);
}

function item_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var sku = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sku"), null));
  if (sku.TAG === /* Ok */0) {
    var quantity = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "quantity"), null));
    if (quantity.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                sku: sku._0,
                quantity: quantity._0
              }
            };
    }
    var e = quantity._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".quantity" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = sku._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".sku" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "address",
                Decco.optionToJson(address_encode, v.address)
              ],
              [
                "items",
                Decco.optionToJson((function (param) {
                        return Decco.arrayToJson(item_encode, param);
                      }), v.items)
              ],
              [
                "crm_status",
                Decco.optionToJson(Decco.stringToJson, v.crm_status)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var address = Decco.optionFromJson(address_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "address"), null));
  if (address.TAG === /* Ok */0) {
    var items = Decco.optionFromJson((function (param) {
            return Decco.arrayFromJson(item_decode, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "items"), null));
    if (items.TAG === /* Ok */0) {
      var crm_status = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "crm_status"), null));
      if (crm_status.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  address: address._0,
                  items: items._0,
                  crm_status: crm_status._0
                }
              };
      }
      var e = crm_status._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".crm_status" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = items._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".items" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = address._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".address" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

export {
  address_encode ,
  address_decode ,
  item_encode ,
  item_decode ,
  t_encode ,
  t_decode ,
  
}
/* No side effect */
